import NavbarV2 from '../../components/navbarV2/NavbarV2';
import './UsersV2.css';
import UsersList from '../../components/UsersList/UsersList';
import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDebouncedValue } from '../../hooks/useDebouncedValue';

const UsersV2 = () => {
    const [accounts, setAccounts] = useState([]);
    const [query, setQuery] = useState('');
    const [debouncedQuery, flushQuery] = useDebouncedValue(query, 350);
    const navigate = useNavigate();

    const fetchAccounts = useCallback((searchQuery) => {
        let url = `${process.env.REACT_APP_API}/api/getAccounts`;
        if (searchQuery.length > 0) url += '?query=' + encodeURIComponent(searchQuery);

        fetch(url, {}).then((response) => {
            if (response.status === 200) {
                if (localStorage.getItem('account') !== null && localStorage.getItem('admin') === 'true') {
                    response.json().then((data) => setAccounts(data));
                } else {
                    navigate('/');
                }
            }
        });
    }, [navigate]);

    useEffect(() => {
        fetchAccounts(debouncedQuery);
    }, [debouncedQuery, fetchAccounts]);

    const changeQuery = (e) => {
        setQuery(e.target.value);
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            flushQuery();
        }
    };

    return (
        <div className="v2-page usersv2">
            <NavbarV2 />

            <div className="v2-container usersv2-inner">
                <h1 className="v2-h1">Customers</h1>
                <p className="v2-muted usersv2-lead">Search and open a customer profile (admin).</p>

                {localStorage.getItem('admin') === 'true' && (
                    <div className="usersv2-search v2-card">
                        <div className="usersv2-search-row">
                            <div className="v2-field usersv2-field">
                                <label htmlFor="users-query">Search</label>
                                <input
                                    type="text"
                                    id="users-query"
                                    value={query}
                                    onChange={changeQuery}
                                    onKeyDown={handleKeyDown}
                                    placeholder="Email, name, phone…"
                                />
                            </div>
                            <button type="button" className="v2-btn v2-btn--primary usersv2-search-btn" onClick={() => flushQuery()}>
                                Search
                            </button>
                        </div>
                    </div>
                )}

                {accounts.length > 0 && (
                    <div className="v2-mui-scope usersv2-mui">
                        <UsersList data={accounts} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default UsersV2;
